import { Box } from '@mui/material';

export const ConsIcon = () => {
  return (
    <Box
      sx={{
        position: 'relative',
        width: 16,
        height: 16,
        borderRadius: '50%',
        backgroundColor: 'reds.lightest',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <svg width="9" height="9" viewBox="0 -0.5 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0.874931 7.1835C0.687523 7.37091 0.687523 7.67475 0.874931 7.86216C1.06234 8.04957 1.36619 8.04957 1.5536 7.86216L4.73332 4.68244L7.93592 7.88503C8.12333 8.07244 8.42717 8.07244 8.61458 7.88503C8.80199 7.69762 8.80199 7.39377 8.61458 7.20637L5.41199 4.00377L8.59654 0.819221C8.78395 0.631813 8.78395 0.327965 8.59654 0.140556C8.40913 -0.0468518 8.10528 -0.0468523 7.91787 0.140556L4.73332 3.32511L1.56988 0.161662C1.38247 -0.0257463 1.07862 -0.0257463 0.891212 0.161662C0.703804 0.34907 0.703805 0.652919 0.891213 0.840328L4.05466 4.00377L0.874931 7.1835Z"
          fill="#B40000"
        />
      </svg>
    </Box>
  );
};
